import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Card = styled.div<{ $highlighted?: boolean; $accentColor: string }>`
  border-radius: 12px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  text-align: center;
  flex: 1;
  min-width: 140px;
  border: ${({ $highlighted, $accentColor, theme }) =>
    $highlighted
      ? `2px solid ${$accentColor}30`
      : `2px solid ${theme.colors['neutral-20']}`};
  transition: box-shadow 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &:hover {
    box-shadow: 0 4px 16px hsla(0, 0%, 0%, 0.16);
  }

  ${media.mobile} {
    padding: 16px;
    min-width: 0;
    border-radius: 8px;
  }
`;

export const Label = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-70']};
  letter-spacing: 0.3px;
`;

export const Value = styled.div<{ $color: string }>`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  color: ${({ $color }) => $color};
  margin-top: 6px;

  ${media.mobile} {
    font-size: 22px;
  }
`;

export const SkeletonValue = styled.div`
  height: 36px;
  width: 60%;
  margin: 6px auto 0;
  background: ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 8px;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
`;

export const Subtitle = styled.span`
  display: block;
  font-size: 11px;
  color: ${({ theme }) => theme.colors['neutral-60']};
  margin-top: 4px;
`;
